export default __webpack_public_path__ + "static/media/copilot.b73d5b31.png";